"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactPdf = require("react-pdf");

require("react-pdf/dist/esm/Page/AnnotationLayer.css");

require("react-pdf/dist/esm/Page/TextLayer.css");

var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));

var _resizeObserver = _interopRequireDefault(require("@react-hook/resize-observer"));

var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));

var _material = require("@mui/material");

var _ArrowForwardIos = _interopRequireDefault(require("@mui/icons-material/ArrowForwardIos"));

var _ArrowBackIos = _interopRequireDefault(require("@mui/icons-material/ArrowBackIos"));

var _CloudDownload = _interopRequireDefault(require("@mui/icons-material/CloudDownload"));

var _OpenInFull = _interopRequireDefault(require("@mui/icons-material/OpenInFull"));

var _CloseFullscreen = _interopRequireDefault(require("@mui/icons-material/CloseFullscreen"));

var _ZoomIn = _interopRequireDefault(require("@mui/icons-material/ZoomIn"));

var _ZoomOut = _interopRequireDefault(require("@mui/icons-material/ZoomOut"));

var _highlighter = require("./highlighter");

var _Snackbar = _interopRequireDefault(require("@mui/material/Snackbar"));

_reactPdf.pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
var HIGHLIGHT_TEXT_SELECTOR = '.react-pdf__Page__textContent [role="presentation"]';
var TEXT_LAYER_SELECTOR = '.react-pdf__Page';
var CANVAS_SELECTOR = '.react-pdf__Page__canvas';
var CUSTOM_SQUARE_SELECTOR = '.custom-square';
var CUSTOM_SQUARE_CLASS_NAME = 'custom-square';
var PDF_DOCUMENT_SELECTOR = '.react-pdf__Document';

var autoScrollToFirstMark = function autoScrollToFirstMark() {
  var firstMark = document.querySelector('span mark');

  if (firstMark) {
    firstMark.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
};

var useWidth = function useWidth(target) {
  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  (0, _react.useLayoutEffect)(function () {
    setWidth(target.current.getBoundingClientRect().width);
  }, [target]);
  (0, _resizeObserver.default)(target, function (entry) {
    return setWidth(entry.contentRect.width);
  });
  return width;
};

var PdfFileRenderer = function PdfFileRenderer(props) {
  var fileName = props.fileName,
      fileBin = props.fileBin,
      previewPage = props.previewPage,
      boundingBox = props.boundingBox,
      imageDimension = props.imageDimension,
      searchText = props.searchText,
      pdfFullHeight = props.pdfFullHeight,
      setPdfFullHeight = props.setPdfFullHeight;

  var _useState3 = (0, _react.useState)(1),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      scale = _useState4[0],
      setScale = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      numPages = _useState6[0],
      setNumPages = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      pageNumber = _useState8[0],
      setPageNumber = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      scanningAllPages = _useState10[0],
      setScanningAllPages = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      snackbackOpen = _useState12[0],
      setSnackbackOpen = _useState12[1];

  var _useState13 = (0, _react.useState)(''),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      snackbackMessage = _useState14[0],
      setSnackbackMessage = _useState14[1];

  var pdfWrapper = (0, _react.useRef)(null);
  var width = useWidth(pdfWrapper);
  var autoHighlight = (0, _react.useCallback)(function () {
    var _Object$keys;

    var spanElements = document.querySelectorAll(HIGHLIGHT_TEXT_SELECTOR);
    var textToHighlight = (0, _highlighter.getTextToHighlight)(spanElements, searchText);
    var excerptFound = Boolean((_Object$keys = Object.keys(textToHighlight)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length);

    if (excerptFound) {
      (0, _highlighter.highlightText)(spanElements, textToHighlight);
      autoScrollToFirstMark();
    }

    return excerptFound;
  }, [searchText]);
  var removeCustomSqure = (0, _react.useCallback)(function () {
    var pdfDocument = document.querySelector(PDF_DOCUMENT_SELECTOR);

    if (pdfDocument) {
      var oldSquare = pdfDocument.querySelector(CUSTOM_SQUARE_SELECTOR);
      if (oldSquare) oldSquare.remove();
    }
  }, []);
  var drawBoundingBox = (0, _react.useCallback)(function () {
    if (!boundingBox || !imageDimension) return false;
    var textLayer = document.querySelector(TEXT_LAYER_SELECTOR);
    var canvas = document.querySelector(CANVAS_SELECTOR);
    if (!textLayer || !canvas) return false;

    if (typeof boundingBox.x1 !== 'number' || typeof boundingBox.y1 !== 'number' || typeof boundingBox.x2 !== 'number' || typeof boundingBox.y2 !== 'number' || typeof imageDimension.width !== 'number' || typeof imageDimension.height !== 'number') {
      return false;
    }

    var textLayerBoundingClientRect = textLayer.getBoundingClientRect();
    var textLayerWidth = textLayerBoundingClientRect.width;
    var textLayerHeight = textLayerBoundingClientRect.height;
    var canvasBoundingClientRect = canvas.getBoundingClientRect();
    var canvasWidth = canvasBoundingClientRect.width;
    var canvasHeight = canvasBoundingClientRect.height;
    var widthRatio = canvasWidth / textLayerWidth;
    var heightRatio = canvasHeight / textLayerHeight;
    var top = boundingBox.y1 / imageDimension.height * 100 * heightRatio;
    var left = boundingBox.x1 / imageDimension.width * 100 * widthRatio;
    var width = (boundingBox.x2 - boundingBox.x1) / imageDimension.width * 100 * widthRatio;
    var height = (boundingBox.y2 - boundingBox.y1) / imageDimension.height * 100 * heightRatio;
    var square = document.createElement('div');
    square.className = CUSTOM_SQUARE_CLASS_NAME;
    square.style.position = 'absolute';
    square.style.top = "".concat(top, "%");
    square.style.left = "".concat(left, "%");
    square.style.width = "".concat(width, "%");
    square.style.height = "".concat(height, "%");
    square.style.border = '1px solid red';
    square.style.background = 'rgba(255,44,33,0.1)';
    square.style.pointerEvents = 'none';
    square.style.zIndex = 10;
    textLayer.appendChild(square);
    square.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    return true;
  }, [boundingBox, imageDimension]);
  var onRenderTextLayerSuccessHandler = (0, _react.useCallback)(function () {
    if (!searchText || !pageNumber) return;
    removeCustomSqure();

    if (previewPage === pageNumber) {
      if (drawBoundingBox()) return;
    }

    var excerptFound = autoHighlight();
    if (previewPage !== null || !scanningAllPages) return;

    if (excerptFound) {
      setSnackbackMessage('Excerpt found');
      setSnackbackOpen(true);
      setScanningAllPages(false);
    } else {
      if (pageNumber < numPages) {
        setPageNumber(function (prevPageNumber) {
          return prevPageNumber + 1;
        });
      } else {
        if (!excerptFound) {
          setSnackbackMessage('Excerpt not found');
          setSnackbackOpen(true);
          setPageNumber(1);
        }

        setScanningAllPages(false);
      }
    }
  }, [pageNumber, scanningAllPages, autoHighlight, numPages, previewPage, searchText]);
  var onDocumentLoadSuccess = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref) {
      var numPages;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              numPages = _ref.numPages;

              if (!previewPage && searchText) {
                setScanningAllPages(true);
                setSnackbackMessage('Searching for excerpt...');
                setSnackbackOpen(true);
              }

              setNumPages(numPages);
              setPageNumber(previewPage || 1);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [previewPage, searchText]);
  var downloadDocument = (0, _react.useCallback)(function () {
    var link = document.createElement('a');
    link.href = URL.createObjectURL(fileBin);
    link.download = "".concat(fileName, ".pdf");
    link.click();
  }, [fileBin, fileName]);
  var changePage = (0, _react.useCallback)(function (offset) {
    setPageNumber(function (prevPageNumber) {
      return prevPageNumber + offset;
    });
  }, []);
  var previousPage = (0, _react.useCallback)(function () {
    changePage(-1);
  }, [changePage]);
  var nextPage = (0, _react.useCallback)(function () {
    changePage(1);
  }, [changePage]);
  var changeScale = (0, _react.useCallback)(function (offset) {
    setScale(function (prevScale) {
      return prevScale + offset;
    });
  }, []);
  var decreaseScale = (0, _react.useCallback)(function () {
    changeScale(-0.1);
  }, [changeScale]);
  var increaseScale = (0, _react.useCallback)(function () {
    changeScale(0.1);
  }, [changeScale]);
  var handleCloseSnackBar = (0, _react.useCallback)(function () {
    setSnackbackOpen(false);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Snackbar.default, {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    open: snackbackOpen,
    onClose: handleCloseSnackBar,
    autoHideDuration: 5000,
    message: snackbackMessage
  }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    style: {
      margin: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "Previous Page"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "previous page",
    disabled: pageNumber <= 1,
    onClick: previousPage
  }, /*#__PURE__*/_react.default.createElement(_ArrowBackIos.default, null)))), !scanningAllPages && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, pageNumber || (numPages ? 1 : '--'), " / ", numPages || '--'), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "Next Page"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "next page",
    disabled: pageNumber >= numPages,
    onClick: nextPage
  }, /*#__PURE__*/_react.default.createElement(_ArrowForwardIos.default, null)))), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "Zoom Out"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "zoom out",
    disabled: scale <= 0.5,
    onClick: decreaseScale
  }, /*#__PURE__*/_react.default.createElement(_ZoomOut.default, null)))), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "Zoom In"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "zoom in",
    disabled: scale >= 2,
    onClick: increaseScale
  }, /*#__PURE__*/_react.default.createElement(_ZoomIn.default, null)))), pdfFullHeight ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "Exit Full Screen"
  }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "exit full screen",
    onClick: function onClick() {
      return setPdfFullHeight(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_CloseFullscreen.default, null))) : /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "Switch to Full Screen"
  }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "switch to full screen",
    onClick: function onClick() {
      return setPdfFullHeight(true);
    }
  }, /*#__PURE__*/_react.default.createElement(_OpenInFull.default, null))), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "Download Document"
  }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "download document",
    onClick: function onClick() {
      return downloadDocument();
    }
  }, /*#__PURE__*/_react.default.createElement(_CloudDownload.default, null))))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    style: {
      width: '100%',
      height: '100%',
      overflow: 'auto',
      border: '1px solid black'
    },
    ref: pdfWrapper
  }, /*#__PURE__*/_react.default.createElement(_reactPdf.Document, {
    style: {
      flexGrow: '1',
      overflow: 'auto',
      position: 'relative',
      width: '100%',
      height: '100%'
    },
    file: fileBin,
    onLoadSuccess: onDocumentLoadSuccess,
    loading: /*#__PURE__*/_react.default.createElement(_CircularProgress.default, null)
  }, scanningAllPages && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      width: width,
      height: '70%',
      backgroundColor: 'rgba(255, 255, 255, 1)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }
  }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, null)), pageNumber && /*#__PURE__*/_react.default.createElement(_reactPdf.Page, {
    scale: scale,
    loading: '',
    pageNumber: pageNumber,
    width: width,
    onRenderTextLayerSuccess: onRenderTextLayerSuccessHandler
  }))));
};

var _default = PdfFileRenderer;
exports.default = _default;